import { Icon } from '@branch-messenger/willow-ui'

import {
  DropdownMenuButtonTrigger,
  DropdownMenuIconButtonTrigger,
} from './styles'
import { DropdownMenuTriggerProps } from './types'

export const DropdownMenuTrigger = ({
  ref,
  Icon: IconProp,
  ...restProps
}: DropdownMenuTriggerProps) => {
  if (IconProp) {
    return (
      <DropdownMenuIconButtonTrigger {...restProps} ref={ref}>
        <Icon Icon={IconProp} size={6} />
      </DropdownMenuIconButtonTrigger>
    )
  }
  return <DropdownMenuButtonTrigger {...restProps} ref={ref} />
}
DropdownMenuTrigger.displayName = 'DropdownMenuTrigger'
